import React from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingCart, User, Menu, X } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

export default function Header() {
  const { count } = useCart();
  const { user } = useAuth();
  const [open, setOpen] = React.useState(false);

  return (
    <header className="glass-header sticky top-0 z-50">
      <div className="max-w-[1500px] mx-auto flex items-center justify-between px-6 md:px-10 h-16">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
          <img src="/brand/card-lobster-mascot.jpg" alt="Card Lobster"
               className="w-10 h-10 rounded-full ring-2 ring-[var(--cl-primary)]/50 object-cover" />
          <span className="font-display text-3xl leading-none tracking-tight">
            CARD<span style={{ color: "var(--cl-primary)" }}>LOBSTER</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-6">
          <NavLink to="/" data-testid="nav-home"
                   className={({ isActive }) => `text-label ${isActive ? "text-white" : "text-zinc-400 hover:text-white"}`}>
            Home
          </NavLink>
          <NavLink to="/shop" data-testid="nav-shop"
                   className={({ isActive }) => `text-label ${isActive ? "text-white" : "text-zinc-400 hover:text-white"}`}>
            Shop Cards
          </NavLink>
          <NavLink to="/mystery-packs" data-testid="nav-mystery"
                   className={({ isActive }) => `text-label ${isActive ? "text-white" : "text-zinc-400 hover:text-white"}`}>
            Mystery Packs
          </NavLink>
          <NavLink to="/sealed" data-testid="nav-sealed"
                   className={({ isActive }) => `text-label ${isActive ? "text-white" : "text-zinc-400 hover:text-white"}`}>
            Sealed Wax
          </NavLink>
          <NavLink to="/pack-contents" data-testid="nav-pack-contents"
                   className={({ isActive }) => `text-label ${isActive ? "text-white" : "text-zinc-400 hover:text-white"}`}>
            Pack Contents
          </NavLink>
          <NavLink to="/subscribe" data-testid="nav-club"
                   className={({ isActive }) => `text-label ${isActive ? "text-white" : "text-zinc-400 hover:text-white"}`}>
            Club
          </NavLink>
          <NavLink to="/live" data-testid="nav-live"
                   className={({ isActive }) => `text-label ${isActive ? "text-white" : "text-zinc-400 hover:text-white"}`}>
            Live Auctions
          </NavLink>
          <NavLink to="/big-hits" data-testid="nav-big-hits"
                   className={({ isActive }) => `text-label ${isActive ? "text-white" : "text-zinc-400 hover:text-white"}`}>
            Big Hits
          </NavLink>
          <NavLink to="/about" data-testid="nav-about"
                   className={({ isActive }) => `text-label ${isActive ? "text-white" : "text-zinc-400 hover:text-white"}`}>
            About
          </NavLink>
        </nav>

        <div className="flex items-center gap-3">
          <Link to="/cart" className="relative p-2 hover:text-[var(--cl-orange)]" data-testid="cart-icon">
            <ShoppingCart size={20} />
            {count > 0 && (
              <span className="absolute -top-1 -right-1 bg-[var(--cl-primary)] text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1" data-testid="cart-badge">
                {count}
              </span>
            )}
          </Link>
          <Link to={user ? "/account" : "/login"} className="p-2 hover:text-[var(--cl-orange)]" data-testid="account-icon">
            <User size={20} />
          </Link>
          {user?.is_admin && (
            <Link to="/admin" data-testid="admin-link"
                  className="hidden md:inline-flex text-[10px] font-bold tracking-widest px-3 py-1.5 rounded border border-[var(--cl-gold)]/50 text-[var(--cl-gold)] hover:bg-[var(--cl-gold)]/10">
              ADMIN
            </Link>
          )}
          <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 px-6 py-4 space-y-3 bg-black/95">
          <Link to="/" onClick={() => setOpen(false)} className="block text-label text-zinc-300 hover:text-white">Home</Link>
          <Link to="/shop" onClick={() => setOpen(false)} className="block text-label text-zinc-300 hover:text-white">Shop Cards</Link>
          <Link to="/mystery-packs" onClick={() => setOpen(false)} className="block text-label text-zinc-300">Mystery Packs</Link>
          <Link to="/sealed" onClick={() => setOpen(false)} className="block text-label text-zinc-300">Sealed Wax</Link>
          <Link to="/pack-contents" onClick={() => setOpen(false)} className="block text-label text-zinc-300">Pack Contents</Link>
          <Link to="/subscribe" onClick={() => setOpen(false)} className="block text-label text-zinc-300">Club</Link>
          <Link to="/live" onClick={() => setOpen(false)} className="block text-label text-zinc-300">Live Auctions</Link>
          <Link to="/big-hits" onClick={() => setOpen(false)} className="block text-label text-zinc-300">Big Hits</Link>
          <Link to="/about" onClick={() => setOpen(false)} className="block text-label text-zinc-300">About</Link>
          {user?.is_admin && (
            <Link to="/admin" onClick={() => setOpen(false)} data-testid="admin-link-mobile" className="block text-label text-[var(--cl-gold)]">ADMIN PANEL</Link>
          )}
        </div>
      )}
    </header>
  );
}
